import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import uuidv4 from 'uuid/v4';

import { SQLite, SQLiteObject, SQLiteTransaction } from '@ionic-native/sqlite';

/*
  Generated class for the SqliteProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SqliteProvider {

  private db: SQLiteObject = null;

  constructor(
    private sqlite: SQLite,
    private platform: Platform,
  ) {
  }

  public initDB(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.platform.ready().then(() => {
        this.sqlite.create({name: 'remotestack.db', location: 'default'}).then((db: SQLiteObject) => {
          this.db = db;
          db.executeSql('create table if not exists shop(id TEXT PRIMARY KEY, name TEXT)', []).then(() => {
            db.executeSql('create table if not exists master(type TEXT PRIMARY KEY, json TEXT)', []).then(() => {
              db.executeSql('create table if not exists members(id TEXT PRIMARY KEY, json TEXT)', []).then(() => {
                db.executeSql('select * from shop', []).then((res) => {
                  console.log(JSON.stringify(res));
                  resolve(res);
                }).catch(err => reject(err));
              }).catch(err => reject(err));
            }).catch(err => reject(err));
          }).catch(err => reject(err));
        }).catch(err => reject(err));
      });
    });
  }

  public insertShop(id: string, name: string): Promise<any> {
    return this.db.executeSql('insert or replace into shop values (?, ?)', [id, name]);
  }

  public insertMaster(type: string, json: string): Promise<any> {
    return this.db.executeSql('insert or replace into master values (?, ?)', [type, json]);
  }

  public selectMaster(type: string): Promise<any> {
    return this.db.executeSql('select * from master where type = ?', [type]);
  }

  public deleteShop(): Promise<any> {
    return this.db.executeSql('delete from shop ?', []);
  }

  public deleteMember(id: string): Promise<any> {
    return this.db.executeSql('delete from members where id = ?', [id]);
  }

  public insert(json: string): Promise<any> {
    // alert('Insert開始');
    return this.db.transaction((tx: SQLiteTransaction) => {
      tx.executeSql('insert or replace into members values (?, ?)', [uuidv4(), json], () => {
        // alert('insert OK');
      }, e => alert('Insert失敗：' + e));
    });
  }

  public select(): Promise<any> {
    return new Promise((resolve, reject) => {
      // alert('Select開始');
      this.db.executeSql(
        'select * from members',
        []
      ).then(res => {
        resolve(res);
        /*for(let i = 0; i < res.rows.length; i++) {
          alert(JSON.stringify(res.rows.item(i)));
        }*/
      }).catch(e => alert('Select失敗：' + e));
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/sqlite/sqlite.ts